import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('./views/index.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import('./views/service.vue')
  },
  {
    path: '/solution',
    name: 'solution',
    component: () => import('./views/solution.vue')
  },
  {
    path: '/case',
    name: 'case',
    component: () => import('./views/case.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('./views/about.vue')
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: () => import('./views/contacts.vue')
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    component: () => import('./views/joinUs.vue')
  },
  {
    path: '/honor',
    name: 'honor',
    component: () => import('./views/honor.vue')
  },
  {
    path: '/afSolutionDetails',
    name: 'afSolutionDetails',
    component: () => import('./views/afSolutionDetails.vue')
  },
  {
    path: '/solutionDetails',
    name: 'solutionDetails',
    component: () => import('./views/solutionDetails.vue')
  },
  {
    path: '/solutionDetails1',
    name: 'solutionDetails1',
    component: () => import('./views/solutionDetails/solutionDetails1.vue')
  },
  {
    path: '/solutionDetails2',
    name: 'solutionDetails2',
    component: () => import('./views/solutionDetails/solutionDetails2.vue')
  },
  {
    path: '/solutionDetails3',
    name: 'solutionDetails3',
    component: () => import('./views/solutionDetails/solutionDetails3.vue')
  },
  {
    path: '/solutionDetails4',
    name: 'solutionDetails4',
    component: () => import('./views/solutionDetails/solutionDetails4.vue')
  },
  {
    path: '/solutionDetails5',
    name: 'solutionDetails5',
    component: () => import('./views/solutionDetails/solutionDetails5.vue')
  },
  {
    path: '/solutionDetails6',
    name: 'solutionDetails6',
    component: () => import('./views/solutionDetails/solutionDetails6.vue')
  },
  {
    path: '/solutionDetails7',
    name: 'solutionDetails7',
    component: () => import('./views/solutionDetails/solutionDetails7.vue')
  },
  {
    path: '/solutionDetails8',
    name: 'solutionDetails8',
    component: () => import('./views/solutionDetails/solutionDetails8.vue')
  },
  {
    path: '/solutionDetails9',
    name: 'solutionDetails9',
    component: () => import('./views/solutionDetails/solutionDetails9.vue')
  },
  {
    path: '/solutionDetails10',
    name: 'solutionDetails10',
    component: () => import('./views/solutionDetails/solutionDetails10.vue')
  },
  {
    path: '/solutionDetails11',
    name: 'solutionDetails11',
    component: () => import('./views/solutionDetails/solutionDetails11.vue')
  },
  {
    path: '/solutionDetails12',
    name: 'solutionDetails12',
    component: () => import('./views/solutionDetails/solutionDetails12.vue')
  },
  {
    path: '/solutionDetails13',
    name: 'solutionDetails13',
    component: () => import('./views/solutionDetails/solutionDetails13.vue')
  },
  {
    path: '/solutionDetails14',
    name: 'solutionDetails14',
    component: () => import('./views/solutionDetails/solutionDetails14.vue')
  },
  {
    path: '/solutionDetails15',
    name: 'solutionDetails15',
    component: () => import('./views/solutionDetails/solutionDetails15.vue')
  }
]

const createRouter = () => new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})
const router = createRouter()
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router
